/* tslint:disable */
/* eslint-disable */
/**
 * External Customer Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const RHIMAPOCommonDataCustomerManagementHmdFeature = {
    LegacyRhView: 'LegacyRhView',
    QckLight: 'QCKLight',
    WearExplorer: 'WearExplorer',
    ParameterComparison: 'ParameterComparison',
    OperatorDisplay: 'OperatorDisplay',
    VolumeCalculations: 'VolumeCalculations',
    ConnectedMachines: 'ConnectedMachines',
} as const;

export type RHIMAPOCommonDataCustomerManagementHmdFeature = typeof RHIMAPOCommonDataCustomerManagementHmdFeature[keyof typeof RHIMAPOCommonDataCustomerManagementHmdFeature];



export const RHIMAPOCommonDataCustomerManagementHmdProduct = {
    QckLight: 'QCKLight',
    Les: 'LES',
    Etec: 'ETEC',
    ConnectedMachines: 'ConnectedMachines',
    PowerBiReports: 'PowerBIReports',
    Predictions: 'Predictions',
    FileShare: 'FileShare',
} as const;

export type RHIMAPOCommonDataCustomerManagementHmdProduct = typeof RHIMAPOCommonDataCustomerManagementHmdProduct[keyof typeof RHIMAPOCommonDataCustomerManagementHmdProduct];



export const RHIMAPOCommonDataCustomerManagementHmdProductState = {
    Active: 'Active',
    NotActiveYet: 'NotActiveYet',
    ExpiringSoon: 'ExpiringSoon',
    Expired: 'Expired',
    Inactive: 'Inactive',
} as const;

export type RHIMAPOCommonDataCustomerManagementHmdProductState = typeof RHIMAPOCommonDataCustomerManagementHmdProductState[keyof typeof RHIMAPOCommonDataCustomerManagementHmdProductState];



export const RHIMAPOCommonDataCustomerManagementIndustry = {
    Steel: 'Steel',
    CementAndLime: 'CementAndLime',
    Nfm: 'NFM',
    Eec: 'EEC',
    Glass: 'Glass',
    Foundry: 'Foundry',
    Minerals: 'Minerals',
    ProcessIndustries: 'ProcessIndustries',
    Internal: 'Internal',
} as const;

export type RHIMAPOCommonDataCustomerManagementIndustry = typeof RHIMAPOCommonDataCustomerManagementIndustry[keyof typeof RHIMAPOCommonDataCustomerManagementIndustry];


export interface RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto {
    /**
     * The Id of the customer to whom the service plan is assigned.
     */
    'customerId': string;
    /**
     * The product for which the service plan is assigned.
     */
    'product': RHIMAPOCommonDataCustomerManagementHmdProduct;
    'servicePlanId': string;
    /**
     * A field for additional notes.
     */
    'notes'?: string | null;
    /**
     * The date when the service plan becomes active.
     */
    'activationOn': string;
    /**
     * The date when the service plan expires.
     */
    'expirationOn'?: string | null;
}


export interface RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto {
    'feature': RHIMAPOCommonDataCustomerManagementHmdFeature;
    'startDate'?: string | null;
    'endDate'?: string | null;
}


export interface RHIMAPOCustomerManagementWebV3ModelsCustomerFeatureOverviewDto {
    'assignedToCustomer': boolean;
    'feature': RHIMAPOCommonDataCustomerManagementHmdFeature;
    'startDate'?: string | null;
    'endDate'?: string | null;
    'lastModifiedBy'?: string | null;
    'lastModifiedOn'?: string | null;
}


export interface RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto {
    'feature': RHIMAPOCommonDataCustomerManagementHmdFeature;
}


export interface RHIMAPOCustomerManagementWebV3ModelsHmdProductDto {
    'state': RHIMAPOCommonDataCustomerManagementHmdProductState;
    'name'?: string | null;
    'displayName'?: string | null;
    'activationOnUtc'?: string | null;
    'expirationOnUtc'?: string | null;
    'servicePlanAssignments'?: Array<RHIMAPOCustomerManagementWebV3ModelsServicePlanAssignmentDto> | null;
}


export interface RHIMAPOCustomerManagementWebV3ModelsServicePlanAssignmentDto {
    /**
     * The Id of the service plan.
     */
    'id': string;
    /**
     * The Id of the customer to whom the service plan is assigned.
     */
    'customerId': string;
    /**
     * The product for which the service plan is assigned.
     */
    'product': RHIMAPOCommonDataCustomerManagementHmdProduct;
    'servicePlanId': string;
    /**
     * A field for additional notes.
     */
    'notes'?: string | null;
    /**
     * The date when the service plan becomes active.
     */
    'activationOnUtc': string;
    /**
     * The date when the service plan expires.
     */
    'expirationOnUtc'?: string | null;
    'modifiedOnUtc'?: string | null;
    'modifiedBy'?: string | null;
    'state': RHIMAPOCommonDataCustomerManagementHmdProductState;
}


export interface RHIMAPOCustomerManagementWebV3ModelsServicePlanLookupDto {
    /**
     * The identifier of the service plan.
     */
    'id': string;
    /**
     * The name of the service plan.
     */
    'name'?: string | null;
    /**
     * To which category the service plan could belong.
     */
    'product'?: RHIMAPOCommonDataCustomerManagementHmdProduct | null;
}


export interface RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto {
    /**
     * The product for which the service plan is assigned.
     */
    'product': RHIMAPOCommonDataCustomerManagementHmdProduct;
    'servicePlanId': string;
    /**
     * A field for additional notes.
     */
    'notes'?: string | null;
    /**
     * The date when the service plan becomes active.
     */
    'activationOn': string;
    /**
     * The date when the service plan expires.
     */
    'expirationOn'?: string | null;
}



export const RHIMContractsFileType = {
    PostMortem: 'PostMortem',
    ProcessData: 'ProcessData',
    ProcessMetrixFiltered: 'ProcessMetrixFiltered',
    ProcessMetrixRaw: 'ProcessMetrixRaw',
    ProcessMetrixVertex: 'ProcessMetrixVertex',
    ProcessMetrixSummary: 'ProcessMetrixSummary',
    ProcessMetrixZip: 'ProcessMetrixZip',
    Stl: 'STL',
    HarmonizedSummary: 'HarmonizedSummary',
    ProcessDataSplit: 'ProcessDataSplit',
    Pts: 'PTS',
    Clinker: 'Clinker',
    KilnFeed: 'KilnFeed',
    HotMeal: 'HotMeal',
    Lignite: 'Lignite',
    StopLogs: 'StopLogs',
    IrScan: 'IRScan',
    KilnShellCooling: 'KilnShellCooling',
    KilnProcessData: 'KilnProcessData',
    FerrotronSummary: 'FerrotronSummary',
} as const;

export type RHIMContractsFileType = typeof RHIMContractsFileType[keyof typeof RHIMContractsFileType];



export const RHIMContractsVesselType = {
    Bof: 'BOF',
    Rh: 'RH',
    Eaf: 'EAF',
    Ladle: 'Ladle',
    Crk: 'CRK',
    Rhl: 'RHL',
    Aod: 'AOD',
    Bfr: 'BFR',
    Srf: 'SRF',
    Cou: 'COU',
    Hml: 'HML',
    Cco: 'CCO',
    Ccy: 'CCY',
    Cca: 'CCA',
    Tun: 'TUN',
    Pcg: 'PCG',
    Hof: 'HOF',
    Anf: 'ANF',
} as const;

export type RHIMContractsVesselType = typeof RHIMContractsVesselType[keyof typeof RHIMContractsVesselType];



/**
 * FeatureAssignmentsApi - axios parameter creator
 */
export const FeatureAssignmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove feature from a customer
         * @summary Remove feature from a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto} [rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomersCustomeridFeatures: async (customerId: string, rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto?: RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomersCustomeridFeatures', 'customerId', customerId)
            const localVarPath = `/customers/{customerId}/features`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all feature assignments of a customer
         * @summary Retrieves all feature assignments of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridFeatures: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomersCustomeridFeatures', 'customerId', customerId)
            const localVarPath = `/customers/{customerId}/features`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add feature to a customer
         * @summary Add feature to a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto} [rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomersCustomeridFeatures: async (customerId: string, rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto?: RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putCustomersCustomeridFeatures', 'customerId', customerId)
            const localVarPath = `/customers/{customerId}/features`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureAssignmentsApi - functional programming interface
 */
export const FeatureAssignmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureAssignmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Remove feature from a customer
         * @summary Remove feature from a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto} [rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto?: RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureAssignmentsApi.deleteCustomersCustomeridFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all feature assignments of a customer
         * @summary Retrieves all feature assignments of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersCustomeridFeatures(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV3ModelsCustomerFeatureOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersCustomeridFeatures(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureAssignmentsApi.getCustomersCustomeridFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add feature to a customer
         * @summary Add feature to a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto} [rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto?: RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureAssignmentsApi.putCustomersCustomeridFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureAssignmentsApi - factory interface
 */
export const FeatureAssignmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureAssignmentsApiFp(configuration)
    return {
        /**
         * Remove feature from a customer
         * @summary Remove feature from a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto} [rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto?: RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all feature assignments of a customer
         * @summary Retrieves all feature assignments of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridFeatures(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV3ModelsCustomerFeatureOverviewDto>> {
            return localVarFp.getCustomersCustomeridFeatures(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add feature to a customer
         * @summary Add feature to a customer
         * @param {string} customerId Customer id to identify the customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto} [rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto] Feature data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto?: RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureAssignmentsApi - object-oriented interface
 */
export class FeatureAssignmentsApi extends BaseAPI {
    /**
     * Remove feature from a customer
     * @summary Remove feature from a customer
     * @param {string} customerId Customer id to identify the customer
     * @param {RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto} [rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto] Feature data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto?: RHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto, options?: RawAxiosRequestConfig) {
        return FeatureAssignmentsApiFp(this.configuration).deleteCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV3ModelsCustomerRemoveFeatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all feature assignments of a customer
     * @summary Retrieves all feature assignments of a customer
     * @param {string} customerId Identifier of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomersCustomeridFeatures(customerId: string, options?: RawAxiosRequestConfig) {
        return FeatureAssignmentsApiFp(this.configuration).getCustomersCustomeridFeatures(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add feature to a customer
     * @summary Add feature to a customer
     * @param {string} customerId Customer id to identify the customer
     * @param {RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto} [rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto] Feature data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putCustomersCustomeridFeatures(customerId: string, rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto?: RHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto, options?: RawAxiosRequestConfig) {
        return FeatureAssignmentsApiFp(this.configuration).putCustomersCustomeridFeatures(customerId, rHIMAPOCustomerManagementWebV3ModelsCustomerAddFeatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServicePlanAssignmentsApi - axios parameter creator
 */
export const ServicePlanAssignmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes all available service plans assigned to a customer
         * @summary Deletes all available service plans assigned to a customer
         * @param {string} servicePlanAssignmentId The id of the service plan assignment to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceplanassignmentsServiceplanassignmentid: async (servicePlanAssignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'servicePlanAssignmentId' is not null or undefined
            assertParamExists('deleteServiceplanassignmentsServiceplanassignmentid', 'servicePlanAssignmentId', servicePlanAssignmentId)
            const localVarPath = `/ServicePlanAssignments/{servicePlanAssignmentId}`
                .replace('{servicePlanAssignmentId}', encodeURIComponent(String(servicePlanAssignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all available service plans assigned to a customer
         * @summary Retrieves all available service plans assigned to a customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceplanassignmentsCustomerid: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getServiceplanassignmentsCustomerid', 'customerId', customerId)
            const localVarPath = `/ServicePlanAssignments/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new service plan assignment for a customer
         * @summary Creates a new service plan assignment for a customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto} [rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postServiceplanassignments: async (rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto?: RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ServicePlanAssignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a service plan assignment for a customer
         * @summary Updates a service plan assignment for a customer
         * @param {string} servicePlanAssignmentId 
         * @param {RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto} [rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putServiceplanassignmentsServiceplanassignmentid: async (servicePlanAssignmentId: string, rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto?: RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'servicePlanAssignmentId' is not null or undefined
            assertParamExists('putServiceplanassignmentsServiceplanassignmentid', 'servicePlanAssignmentId', servicePlanAssignmentId)
            const localVarPath = `/ServicePlanAssignments/{servicePlanAssignmentId}`
                .replace('{servicePlanAssignmentId}', encodeURIComponent(String(servicePlanAssignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServicePlanAssignmentsApi - functional programming interface
 */
export const ServicePlanAssignmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServicePlanAssignmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes all available service plans assigned to a customer
         * @summary Deletes all available service plans assigned to a customer
         * @param {string} servicePlanAssignmentId The id of the service plan assignment to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServicePlanAssignmentsApi.deleteServiceplanassignmentsServiceplanassignmentid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all available service plans assigned to a customer
         * @summary Retrieves all available service plans assigned to a customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceplanassignmentsCustomerid(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV3ModelsHmdProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceplanassignmentsCustomerid(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServicePlanAssignmentsApi.getServiceplanassignmentsCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new service plan assignment for a customer
         * @summary Creates a new service plan assignment for a customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto} [rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postServiceplanassignments(rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto?: RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOCustomerManagementWebV3ModelsServicePlanAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postServiceplanassignments(rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServicePlanAssignmentsApi.postServiceplanassignments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a service plan assignment for a customer
         * @summary Updates a service plan assignment for a customer
         * @param {string} servicePlanAssignmentId 
         * @param {RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto} [rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId: string, rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto?: RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId, rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServicePlanAssignmentsApi.putServiceplanassignmentsServiceplanassignmentid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServicePlanAssignmentsApi - factory interface
 */
export const ServicePlanAssignmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServicePlanAssignmentsApiFp(configuration)
    return {
        /**
         * Deletes all available service plans assigned to a customer
         * @summary Deletes all available service plans assigned to a customer
         * @param {string} servicePlanAssignmentId The id of the service plan assignment to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all available service plans assigned to a customer
         * @summary Retrieves all available service plans assigned to a customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceplanassignmentsCustomerid(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV3ModelsHmdProductDto>> {
            return localVarFp.getServiceplanassignmentsCustomerid(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new service plan assignment for a customer
         * @summary Creates a new service plan assignment for a customer
         * @param {RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto} [rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postServiceplanassignments(rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto?: RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOCustomerManagementWebV3ModelsServicePlanAssignmentDto> {
            return localVarFp.postServiceplanassignments(rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a service plan assignment for a customer
         * @summary Updates a service plan assignment for a customer
         * @param {string} servicePlanAssignmentId 
         * @param {RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto} [rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId: string, rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto?: RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId, rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServicePlanAssignmentsApi - object-oriented interface
 */
export class ServicePlanAssignmentsApi extends BaseAPI {
    /**
     * Deletes all available service plans assigned to a customer
     * @summary Deletes all available service plans assigned to a customer
     * @param {string} servicePlanAssignmentId The id of the service plan assignment to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId: string, options?: RawAxiosRequestConfig) {
        return ServicePlanAssignmentsApiFp(this.configuration).deleteServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all available service plans assigned to a customer
     * @summary Retrieves all available service plans assigned to a customer
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getServiceplanassignmentsCustomerid(customerId: string, options?: RawAxiosRequestConfig) {
        return ServicePlanAssignmentsApiFp(this.configuration).getServiceplanassignmentsCustomerid(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new service plan assignment for a customer
     * @summary Creates a new service plan assignment for a customer
     * @param {RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto} [rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postServiceplanassignments(rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto?: RHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto, options?: RawAxiosRequestConfig) {
        return ServicePlanAssignmentsApiFp(this.configuration).postServiceplanassignments(rHIMAPOCustomerManagementWebV3ModelsAddServicePlanAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a service plan assignment for a customer
     * @summary Updates a service plan assignment for a customer
     * @param {string} servicePlanAssignmentId 
     * @param {RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto} [rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId: string, rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto?: RHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto, options?: RawAxiosRequestConfig) {
        return ServicePlanAssignmentsApiFp(this.configuration).putServiceplanassignmentsServiceplanassignmentid(servicePlanAssignmentId, rHIMAPOCustomerManagementWebV3ModelsUpdateServicePlanAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServicePlansApi - axios parameter creator
 */
export const ServicePlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves all available service plans
         * @summary Retrieves all available service plans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceplans: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ServicePlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServicePlansApi - functional programming interface
 */
export const ServicePlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServicePlansApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves all available service plans
         * @summary Retrieves all available service plans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceplans(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCustomerManagementWebV3ModelsServicePlanLookupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceplans(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServicePlansApi.getServiceplans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServicePlansApi - factory interface
 */
export const ServicePlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServicePlansApiFp(configuration)
    return {
        /**
         * Retrieves all available service plans
         * @summary Retrieves all available service plans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceplans(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCustomerManagementWebV3ModelsServicePlanLookupDto>> {
            return localVarFp.getServiceplans(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServicePlansApi - object-oriented interface
 */
export class ServicePlansApi extends BaseAPI {
    /**
     * Retrieves all available service plans
     * @summary Retrieves all available service plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getServiceplans(options?: RawAxiosRequestConfig) {
        return ServicePlansApiFp(this.configuration).getServiceplans(options).then((request) => request(this.axios, this.basePath));
    }
}



